import React from "react";
import ReactDOM from "react-dom/client";
import SubcontractorCompliance from "./subcontractor-compliance";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SubcontractorCompliance />
  </React.StrictMode>,
);
